import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getCaseloadList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCaseloadListCount = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCaseload = ({ caseloadId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/${caseloadId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createCaseload = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateCaseload = ({ caseloadId, payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/${caseloadId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteCaseload = ({ caseloadId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/${caseloadId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const assignStudentToCaseload = ({
  caseloadId,
  payload,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/roster/caseloads/${caseloadId}/assign/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentTagList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentTag = ({ studentTagId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/${studentTagId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createStudentTag = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentTag = ({
  studentTagId,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/${studentTagId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteStudentTag = ({ studentTagId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/${studentTagId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const assignStudentToStudentTag = ({
  studentTagId,
  payload,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/roster/student-tags/${studentTagId}/assign/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
